import { render, staticRenderFns } from "./AddProjectComponent.vue?vue&type=template&id=3c7b9c8e&scoped=true&"
import script from "./AddProjectComponent.vue?vue&type=script&lang=js&"
export * from "./AddProjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectComponent.vue?vue&type=style&index=0&id=3c7b9c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b9c8e",
  null
  
)

export default component.exports